import { apolloClient } from '@/apollo/client'

import { COMMISSION_TURNOVER_REPORTS_CREATE_MUTATION } from '@/graphql/commissionTurnoverReport/commissionTurnoverReports'

export const CommissionTurnoverReportService = {
    createBulk (variables) {
        return apolloClient.mutate({
            mutation: COMMISSION_TURNOVER_REPORTS_CREATE_MUTATION,
            variables,
        }).then(response => response.data.commissionTurnoverReportsCreate)
    },
}
